import {
  DATA_PROVIDERS,
  ViewService,
  BreadcrumbService,
  ConfigService,
  AuthService,
  NotificationService,
  BrokerService,
  HttpService,
  ERROR_HANDLER_PROVIDERS,
} from "./";

import { DefaultUrlSerializer, UrlTree, UrlSerializer } from "@angular/router";

// let configFactory = ( configService: ConfigService) => {
//     return configService.get();
// };

// let configProvider = { provide: Config, useFactory: configFactory, deps: [ConfigService] };

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(url.toLowerCase());
  }
}

const urlSerializerProvider = { provide: UrlSerializer, useClass: LowerCaseUrlSerializer };

const INFRASTRUCTURE_PROVIDERS: any[] = [
  ViewService,
  BreadcrumbService,
  ConfigService,
  AuthService,
  NotificationService,
  BrokerService,
  HttpService,
  urlSerializerProvider,
];

export const SERVICE_PROVIDERS: any[] =
  INFRASTRUCTURE_PROVIDERS.concat(DATA_PROVIDERS).concat(ERROR_HANDLER_PROVIDERS);
